import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { DynamicComponentDirective, MenuContentItem } from '@frontend/vanilla/core';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    standalone: true,
    selector: 'vn-container',
    imports: [CommonModule, DynamicComponentDirective],
    templateUrl: './container.html',
})
export class ContainerComponent extends AccountMenuItemBase implements OnInit {
    leftItems: MenuContentItem | undefined;
    rightItems: MenuContentItem | undefined;
    ngOnInit(): void {
        this.leftItems = this.item.children.find((x) => x.name === 'leftitems');
        this.rightItems = this.item.children.find((x) => x.name === 'rightitems');
    }
}
